var FileWrapper = require('filewrapper');
var Message = require('message');

require('slackBlock.scss');

// Bind `this` to a formatter instance when using this module

export function render (message) {
    var blocks = '';
    var blockParts = message.getSlackBlocks().map(block => {
        var blockPart = '';
        switch (block.type) {
        case 'divider':
            blockPart = '<hr class="slack_block__divider">';
            break;
        case 'context':
            blockPart = '<div class="slack_block__section slack_block__section--context">';
            block.elements.forEach(element => {
                if (element.type === 'image') {
                    blockPart += '<div' + this.makeAttributes({
                        'class': 'slack_block__context_image',
                        style: 'background-image: url("' + element.image_url + '");',
                        title: element.alt_text,
                        'aria-label': element.alt_text
                    }) + '></div>';
                } else if (element.text) {
                    blockPart += '<div class="slack_block__context_text">' + this.renderLinkify(element.text, {
                        replacements: Message.getCustomEmoji(element.text_emoji),
                        codeSpan: message.buffer.formatCodeSpan(),
                        codeBlock: message.buffer.formatCodeBlock(),
                        quote: message.buffer.formatQuote()
                    }) + '</div>';
                }
            });
            // TODO block.elements can contain sub image blocks and text objects
            blockPart += '</div>';
            break;
        case 'call':
            blockPart = '<div class="slack_block__section slack_block__section--call">';

            blockPart += '<div class="slack_block__call_header">';
            
            blockPart += '<div' + this.makeAttributes({
                'class': 'slack_block__call_icon',
                style: 'background-image: url("' + block.call.v1.app_icon_urls.image_48 + '");'
            }) + '></div>';

            blockPart += '<div class="slack_block__call_header_text">';

            blockPart += '<p class="slack_block__call_title">';
            blockPart += this.escapeText(block.call.v1.name);
            blockPart += '</p>';
            blockPart += '<p class="slack_block__call_status">';
            blockPart += 'Started ' + this.timestamp(new Date(block.call.v1.date_start * 1000));
            blockPart += '</p>';

            blockPart += '</div>';

            blockPart += '</div>';

            blockPart += '<div class="slack_block__call_description">';
            blockPart += 'Meeting ID: ' + this.escapeText(block.call.v1.display_id);
            blockPart += '</div>';

            blockPart += '<div class="slack_block__call_join">';
            blockPart += '<button type="button" class="action">';
            blockPart += this.linker.make('Join', {
                href: block.call.v1.join_url,
                target: '_blank',
                rel: 'noreferrer'
            });
            blockPart += '</button>';
            blockPart += '</div>';

            blockPart += '</div>';
            break;
        case 'image':
            blockPart = '<div class="slack_block__section slack_block__section--image">';
            
            blockPart += '<p class="slack_block__image_info">';
            if (block.title && block.title.text) {
                blockPart += this.escapeText(block.title.text) + ' ';
            }
            blockPart += '<span class="slack_block__image_bytes">(';
            blockPart += FileWrapper.sizeToString(block.image_bytes);
            blockPart += ')</span> ';
            blockPart += '</p>';

            var image = '<img' + this.makeAttributes({
                'class': 'slack_block__image',
                src: block.image_url,
                width: block.image_width,
                height: block.image_height,
                alt: block.alt_text
            }) + '>';

            blockPart += '<div class="slack_block__image_wrap">';
            blockPart += this.linker.make(image, {
                'class': 'slack_block__image_link',
                href: block.image_url,
                target: '_blank',
                rel: 'noreferrer'
            });
            blockPart += '</div>';

            blockPart += '</div>';
            break;
        case 'section':
            blockPart = '<div class="slack_block__section slack_block__section--default">';

            blockPart += '<div class="slack_block__text_block">';

            if (block.text) {
                blockPart += '<div class="slack_block__text">' + this.renderLinkify(block.text.text, {
                    replacements: Message.getCustomEmoji(block.text.text_emoji),
                    codeSpan: message.buffer.formatCodeSpan(),
                    codeBlock: message.buffer.formatCodeBlock(),
                    quote: message.buffer.formatQuote()
                }) + '</div>';
            }

            if (block.fields) {
                blockPart += '<div class="slack_block__fields">';
                block.fields.forEach(field => {
                    blockPart += '<div class="slack_block__field">' + this.renderLinkify(field.text, {
                        replacements: Message.getCustomEmoji(field.text_emoji),
                        codeSpan: message.buffer.formatCodeSpan(),
                        codeBlock: message.buffer.formatCodeBlock(),
                        quote: message.buffer.formatQuote()
                    }) + '</div>';
                });
                blockPart += '</div>';
            }

            blockPart += '</div>';

            if (block.accessory && block.accessory.type === 'image') {
                blockPart += '<div' + this.makeAttributes({
                    'class': 'slack_block__accessory_image',
                    style: 'background-image: url("' + block.accessory.image_url + '");',
                    title: block.accessory.alt_text,
                    'aria-label': block.accessory.alt_text
                }) + '></div>';
            }

            blockPart += '</div>';
            break;
        case 'table':
            blockPart = '<div class="slack_block__section slack_block__section--default">';

            blockPart += '<table class="slack_block__table_block">';

            block.rows.forEach(row => {
                blockPart += '<tr>';
                row.forEach(col => {
                    blockPart += '<td>';
                    if (col.type == 'raw_text') {
                        blockPart += this.renderLinkify(col.text, {
                            replacements: Message.getCustomEmoji(col.text_emoji),
                            codeSpan: message.buffer.formatCodeSpan(),
                            codeBlock: message.buffer.formatCodeBlock(),
                            quote: message.buffer.formatQuote()
                        });
                    } else if (col.type == 'rich_text') {
                        col.elements.forEach(el => {
                            if (el.type == 'rich_text_section') {
                                el.elements.forEach(rich_el => {
                                    if (rich_el.type == 'link') {
                                        blockPart += this.linker.make(this.escapeText(rich_el.text), {
                                            href: rich_el.url,
                                            target: '_blank',
                                            rel: 'noreferrer'
                                        });
                                    } else if (rich_el.type == 'text') {
                                        if (rich_el.style && rich_el.style.bold) {
                                            blockPart += '<b>';
                                        }
                                        if (rich_el.style && rich_el.style.italic) {
                                            blockPart += '<i>';
                                        }
                                        if (rich_el.style && rich_el.style.strike) {
                                            blockPart += '<del>';
                                        }
                                        blockPart += this.escapeText(rich_el.text);
                                        if (rich_el.style && rich_el.style.strike) {
                                            blockPart += '</del>';
                                        }
                                        if (rich_el.style && rich_el.style.italic) {
                                            blockPart += '</i>';
                                        }
                                        if (rich_el.style && rich_el.style.bold) {
                                            blockPart += '</b>';
                                        }
                                    }
                                });
                            }
                        });
                    }
                    blockPart += '</td>';
                });
                blockPart += '</tr>';
            });

            blockPart += '</table>';

            blockPart += '</div>';
            break;
        }
        return blockPart;
    });
    return blockParts.join('');
}



// WEBPACK FOOTER //
// ./app/src/format/slackBlock.es6